/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
document.addEventListener('DOMContentLoaded', function() {
  const subscriptionLabels = document.querySelectorAll('.shopify_subscriptions_app_block_label');
  if (subscriptionLabels[2]) subscriptionLabels[2].hidden = true;

  const select = document.querySelector('#billingAddressForm select[name="countryCode"]');

  if (select && select.options.length > 0) {
    select.removeChild(select.options[0]);
  }
}, { once: true });
